/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 7eb9c1c0dffdc8fcb2b804725b5a8865 */

import { ConcreteRequest } from "relay-runtime";

export type ApprovalStatus = "ACTIVE" | "ARCHIVED" | "INACTIVE" | "PENDING" | "%future added value";
export type CountryCode = "AE" | "AR" | "AT" | "AU" | "BE" | "BG" | "BR" | "CA" | "CH" | "CL" | "CN" | "CO" | "CR" | "CZ" | "DE" | "DK" | "EC" | "EE" | "EG" | "ES" | "FI" | "FL" | "FR" | "GB" | "GR" | "GT" | "HR" | "HU" | "IE" | "IN" | "IT" | "JP" | "KE" | "KR" | "LT" | "LU" | "LV" | "MA" | "MX" | "MY" | "NL" | "NO" | "NZ" | "PA" | "PE" | "PL" | "PT" | "RO" | "SA" | "SE" | "SG" | "SI" | "SK" | "TN" | "TR" | "UA" | "UK" | "UM" | "US" | "VG" | "VI" | "ZA" | "%future added value";
export type CurrencyCode = "CAD" | "EUR" | "GBP" | "INR" | "MXN" | "USD" | "%future added value";
export type DigitalRiverCreditCardBrand = "AMERICAN_EXPRESS" | "DISCOVER" | "MASTERCARD" | "VISA" | "%future added value";
export type DigitalRiverPaymentSourceState = "CANCELLED" | "CHARGEABLE" | "CONSUMED" | "FAILED" | "PENDING_FUNDS" | "PENDING_REDIRECT" | "REQUIRES_ACTION" | "%future added value";
export type DigitalRiverPaymentType = "CREDIT_CARD" | "PAYPAL" | "%future added value";
export type PartnerProgramEnrollmentStatus = "ACTIVE" | "CANCELLED" | "EXPIRED" | "NOT_STARTED" | "PENDING" | "WITHDRAWN" | "%future added value";
export type ProgramOfferingVariation = "ADVANCED" | "BASIC" | "%future added value";
export type CartRoutesQueryVariables = {};
export type CartRoutesQueryResponse = {
    readonly viewer: {
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly contactEmail: string | null;
        readonly primaryPhoneNumber: string | null;
        readonly phoneNumbers: ReadonlyArray<{
            readonly number: string | null;
        } | null> | null;
        readonly partnerUsers: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id?: string | null | undefined;
                    readonly partnerAccount?: {
                        readonly contactEmail: string | null;
                        readonly primaryPhoneNumber: string | null;
                        readonly status: ApprovalStatus | null;
                        readonly shipToAddress: {
                            readonly addressLine1: string | null;
                            readonly addressLine2: string | null;
                            readonly city: string | null;
                            readonly stateProvinceRegionCode: string | null;
                            readonly zipPostalCode: string | null;
                            readonly countryCode: CountryCode | null;
                        } | null;
                        readonly partnerProgramEnrollments: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly id: string | null;
                                    readonly status: PartnerProgramEnrollmentStatus | null;
                                    readonly partnerProgram: {
                                        readonly name: string | null;
                                    } | null;
                                    readonly variation?: ProgramOfferingVariation | null | undefined;
                                };
                            } | null>;
                        } | null;
                        readonly id: string | null;
                        readonly name: string | null;
                        readonly partnerBillings: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly id?: string | null | undefined;
                                    readonly billingCustomerNumber?: string | null | undefined;
                                    readonly defaultShipTo?: {
                                        readonly firstName: string | null;
                                        readonly lastName: string | null;
                                        readonly email: string | null;
                                        readonly organization: string | null;
                                        readonly address: {
                                            readonly addressLine1: string | null;
                                            readonly addressLine2: string | null;
                                            readonly city: string | null;
                                            readonly stateProvinceRegionCode: string | null;
                                            readonly zipPostalCode: string | null;
                                            readonly countryCode: CountryCode | null;
                                            readonly mailingAddressName: string | null;
                                            readonly contactName: string | null;
                                        } | null;
                                    } | null | undefined;
                                    readonly defaultBillTo?: {
                                        readonly firstName: string | null;
                                        readonly lastName: string | null;
                                        readonly email: string | null;
                                        readonly organization: string | null;
                                        readonly address: {
                                            readonly addressLine1: string | null;
                                            readonly addressLine2: string | null;
                                            readonly city: string | null;
                                            readonly stateProvinceRegionCode: string | null;
                                            readonly zipPostalCode: string | null;
                                            readonly countryCode: CountryCode | null;
                                            readonly mailingAddressName: string | null;
                                            readonly contactName: string | null;
                                        } | null;
                                    } | null | undefined;
                                    readonly taxCertificate?: {
                                        readonly companyName: string | null;
                                        readonly taxAuthority: string | null;
                                        readonly startDate: string | null;
                                        readonly endDate: string | null;
                                    } | null | undefined;
                                    readonly paymentSources?: ReadonlyArray<{
                                        readonly paymentSourceId: string | null;
                                        readonly clientSecret: string | null;
                                        readonly state: DigitalRiverPaymentSourceState | null;
                                        readonly type: DigitalRiverPaymentType | null;
                                        readonly paymentSessionId: string | null;
                                        readonly currency: CurrencyCode | null;
                                        readonly creditCard: {
                                            readonly lastFourDigits: string | null;
                                            readonly expirationMonth: number | null;
                                            readonly expirationYear: number | null;
                                            readonly brand: DigitalRiverCreditCardBrand | null;
                                        } | null;
                                        readonly billTo: {
                                            readonly firstName: string | null;
                                            readonly lastName: string | null;
                                            readonly email: string | null;
                                            readonly organization: string | null;
                                            readonly address: {
                                                readonly addressLine1: string | null;
                                                readonly addressLine2: string | null;
                                                readonly city: string | null;
                                                readonly stateProvinceRegionCode: string | null;
                                                readonly zipPostalCode: string | null;
                                                readonly countryCode: CountryCode | null;
                                                readonly mailingAddressName: string | null;
                                                readonly contactName: string | null;
                                            } | null;
                                        } | null;
                                    } | null> | null | undefined;
                                };
                            } | null>;
                        } | null;
                    } | null | undefined;
                };
            } | null>;
        } | null;
    } | null;
};
export type CartRoutesQuery = {
    readonly response: CartRoutesQueryResponse;
    readonly variables: CartRoutesQueryVariables;
};



/*
query CartRoutesQuery {
  viewer {
    firstName
    lastName
    contactEmail
    primaryPhoneNumber
    phoneNumbers {
      number
    }
    partnerUsers {
      edges {
        node {
          __typename
          ... on PartnerUser {
            id
            partnerAccount {
              contactEmail
              primaryPhoneNumber
              status
              shipToAddress {
                addressLine1
                addressLine2
                city
                stateProvinceRegionCode
                zipPostalCode
                countryCode
              }
              partnerProgramEnrollments {
                edges {
                  node {
                    __typename
                    id
                    status
                    partnerProgram {
                      __typename
                      name
                      id
                    }
                    ... on AirCyclePartnerProgramEnrollment {
                      variation
                    }
                  }
                }
              }
              id
              name
              partnerBillings {
                edges {
                  node {
                    __typename
                    ... on DigitalRiverBilling {
                      id
                      billingCustomerNumber
                      defaultShipTo {
                        firstName
                        lastName
                        email
                        organization
                        address {
                          addressLine1
                          addressLine2
                          city
                          stateProvinceRegionCode
                          zipPostalCode
                          countryCode
                          mailingAddressName
                          contactName
                        }
                      }
                      defaultBillTo {
                        firstName
                        lastName
                        email
                        organization
                        address {
                          addressLine1
                          addressLine2
                          city
                          stateProvinceRegionCode
                          zipPostalCode
                          countryCode
                          mailingAddressName
                          contactName
                        }
                      }
                      taxCertificate {
                        companyName
                        taxAuthority
                        startDate
                        endDate
                      }
                      paymentSources {
                        paymentSourceId
                        clientSecret
                        state
                        type
                        paymentSessionId
                        currency
                        creditCard {
                          lastFourDigits
                          expirationMonth
                          expirationYear
                          brand
                        }
                        billTo {
                          firstName
                          lastName
                          email
                          organization
                          address {
                            addressLine1
                            addressLine2
                            city
                            stateProvinceRegionCode
                            zipPostalCode
                            countryCode
                            mailingAddressName
                            contactName
                          }
                        }
                      }
                    }
                    id
                  }
                }
              }
            }
          }
          id
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryPhoneNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumbers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine1",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLine2",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "shipToAddress",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variation",
      "storageKey": null
    }
  ],
  "type": "AirCyclePartnerProgramEnrollment",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingCustomerNumber",
  "storageKey": null
},
v17 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organization",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mailingAddressName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverShipTo",
  "kind": "LinkedField",
  "name": "defaultShipTo",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverBillTo",
  "kind": "LinkedField",
  "name": "defaultBillTo",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverTaxCertificate",
  "kind": "LinkedField",
  "name": "taxCertificate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxAuthority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverPaymentSource",
  "kind": "LinkedField",
  "name": "paymentSources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientSecret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverCreditCard",
      "kind": "LinkedField",
      "name": "creditCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFourDigits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brand",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverBillTo",
      "kind": "LinkedField",
      "name": "billTo",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CartRoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerProgramEnrollmentConnection",
                                "kind": "LinkedField",
                                "name": "partnerProgramEnrollments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PartnerProgramEnrollmentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "partnerProgram",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CorePartnerBillingConnection",
                                "kind": "LinkedField",
                                "name": "partnerBillings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CorePartnerBillingEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v5/*: any*/),
                                              (v16/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "type": "DigitalRiverBilling",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CartRoutesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerProgramEnrollmentConnection",
                                "kind": "LinkedField",
                                "name": "partnerProgramEnrollments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PartnerProgramEnrollmentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "partnerProgram",
                                            "plural": false,
                                            "selections": [
                                              (v22/*: any*/),
                                              (v14/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CorePartnerBillingConnection",
                                "kind": "LinkedField",
                                "name": "partnerBillings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CorePartnerBillingEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v16/*: any*/),
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "type": "DigitalRiverBilling",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7eb9c1c0dffdc8fcb2b804725b5a8865",
    "metadata": {},
    "name": "CartRoutesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '9970de3f47d7d7103eca69b4b81d6366';
export default node;
